import alert from '@/utils/shared/alert';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useCopy = () => {
  const { t: tCommon } = useTranslation('translation', {
    keyPrefix: 'common',
  });
  const [timerId, setTimerId] = useState<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const [isCopied, setIsCopied] = useState(false);

  const startTimeout = () => {
    const timer = setTimeout(() => {
      setIsCopied(false);
      setTimerId(null);
    }, 2000);
    setTimerId(timer);
  };

  const handleCopy = (text: string) => {
    if (isCopied && timerId) {
      clearTimeout(timerId);
      startTimeout();
      return;
    }
    navigator.clipboard.writeText(text);
    alert.success(tCommon('copied'));
    setIsCopied(true);
    startTimeout();
  };

  return {
    isCopied,
    handleCopy,
  };
};
